(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var poster = event.target.closest('[data-pf-embed]');
    if (!poster) return;
    event.preventDefault();
    var frame = document.createElement('iframe');
    frame.src = poster.getAttribute('data-pf-embed');
    frame.title = poster.getAttribute('data-pf-title');
    frame.allow = 'autoplay; fullscreen; picture-in-picture';
    frame.allowFullscreen = true;
    poster.replaceWith(frame);
    frame.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
